import { useState, useEffect, useRef } from 'react';
import { useApp } from '../AppContext';
import cFirstLogo from '../images/SwiftCheqLogo.png';

const NAV_ITEMS = [
  { label: 'Dashboard', page: 'dashboard' },
  { label: 'New Order', page: 'new-order' },
  { label: 'My Orders', page: 'orders' },
  { label: 'Wallet', page: 'wallet' },
  { label: 'Reports', page: 'reports' },
  { label: 'Settings', page: 'settings' },
];

export default function TopNav({ currentPage, onNavigate }) {
  const { walletBalance, notifications, user, logout } = useApp();
  const [menuOpen, setMenuOpen] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    if (!menuOpen) return;
    function handleOutside(e) {
      if (menuRef.current && !menuRef.current.contains(e.target)) setMenuOpen(false);
    }
    document.addEventListener('mousedown', handleOutside);
    return () => document.removeEventListener('mousedown', handleOutside);
  }, [menuOpen]);

  function handleLogout() {
    logout();
    onNavigate('login');
    setMenuOpen(false);
  }

  const companyName = user?.clientname || user?.client_name || user?.companyname || user?.name || user?.username || 'Account';
  const email       = user?.email || user?.email_address || user?.emailaddress || user?.username || '';
  const initials    = companyName.split(' ').filter(Boolean).map(w => w[0]).join('').slice(0, 2).toUpperCase() || 'U';

  return (
    <>
    <nav className="topnav">
      <div className="logo" onClick={() => onNavigate('dashboard')}>
        <img src={cFirstLogo} alt="cFIRST BGV" style={{ height: '36px', width: 'auto' }} />
      </div>
      <div className="navmenu">
        {NAV_ITEMS.map(item => (
          <div
            key={item.page}
            className={`ni ${currentPage === item.page ? 'on' : ''}`}
            onClick={() => onNavigate(item.page)}
          >
            {item.label}
          </div>
        ))}
      </div>
      <div className="navr">
        <div className="wpill" onClick={() => onNavigate('wallet')}>
          <div>
            <div className="wpl">Credits</div>
            <div className="wpa">₹{walletBalance.toLocaleString('en-IN')}</div>
          </div>
          <span>💰</span>
        </div>
        {/* <div className="ibtn">
          🔔
          {notifications > 0 && <span className="badge">{notifications}</span>}
        </div> */}
        <button className="hamburger" onClick={() => setMobileOpen(o => !o)} aria-label="Menu">
          <span /><span /><span />
        </button>

        {/* Avatar + dropdown */}
        <div style={{ position: 'relative' }} ref={menuRef}>
          <div className="av" onClick={() => setMenuOpen(o => !o)}>{initials}</div>

          {menuOpen && (
            <div style={{
              position: 'absolute', right: 0, top: 'calc(100% + 8px)',
              background: 'var(--wh)', border: '1px solid var(--g200)',
              borderRadius: 10, boxShadow: '0 4px 24px rgba(0,0,0,.13)',
              minWidth: 230, zIndex: 300, overflow: 'hidden',
            }}>
              {/* Profile header */}
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '14px 16px', borderBottom: '1px solid var(--g100)', background: 'var(--g50)' }}>
                <div className="av" style={{ flexShrink: 0, pointerEvents: 'none' }}>{initials}</div>
                <div style={{ minWidth: 0 }}>
                  <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--nv)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{companyName}</div>
                  {email && <div style={{ fontSize: 11, color: 'var(--g400)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', marginTop: 2 }}>{email}</div>}
                </div>
              </div>

              {/* Menu items */}
              {[
                { icon: '👤', label: 'My Profile',       action: () => { onNavigate('settings', { initialTab: 0, navTs: Date.now() }); setMenuOpen(false); } },
                { icon: '🔑', label: 'Change Password',  action: () => { onNavigate('settings', { initialTab: 5, navTs: Date.now() }); setMenuOpen(false); } },
              ].map(item => (
                <MenuItem key={item.label} icon={item.icon} label={item.label} onClick={item.action} />
              ))}

              <div style={{ borderTop: '1px solid var(--g100)' }}>
                <MenuItem icon="🚪" label="Logout" onClick={handleLogout} danger />
              </div>
            </div>
          )}
        </div>
      </div>
    </nav>

    {mobileOpen && (
      <div className="mobile-nav">
        {NAV_ITEMS.map(item => (
          <div
            key={item.page}
            className={`mobile-nav-item ${currentPage === item.page ? 'on' : ''}`}
            onClick={() => { onNavigate(item.page); setMobileOpen(false); }}
          >
            {item.label}
          </div>
        ))}
      </div>
    )}
    </>
  );
}

function MenuItem({ icon, label, onClick, danger }) {
  const [hovered, setHovered] = useState(false);
  return (
    <div
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        display: 'flex', alignItems: 'center', gap: 9,
        padding: '10px 16px', fontSize: 13, cursor: 'pointer',
        color: danger ? 'var(--rd)' : 'var(--nv)',
        fontWeight: danger ? 600 : 400,
        background: hovered ? (danger ? 'rgba(220,38,38,.05)' : 'var(--g50)') : 'transparent',
        transition: 'background .12s',
      }}
    >
      <span style={{ fontSize: 14 }}>{icon}</span>
      {label}
    </div>
  );
}
